import React from "react";
import gif from '../../assets/2iiJ.gif'


const Footer = () => {
  return <footer>
        <img src={gif} alt="" srcset="" />

  </footer>;
};

export default Footer;
